import { ReducerEnum, sessionIDReducer } from "./reducer"
import { configureStore } from "@reduxjs/toolkit"

export const store = configureStore(
    {
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                immutableCheck: {
                    ignoredPaths: [
                        'currentNavigation.livedataRootContainer.dataRoot',
                        'ListData',
                    ],
                },
                serializableCheck: {
                    ignoredActions: [String(ReducerEnum.SET_ROOT)],
                    ignoredActionPaths: ['payload'],
                    ignoredPaths: [
                        'currentNavigation.livedataRootContainer.dataRoot',
                    ],
                }
            }),
        reducer: sessionIDReducer,
        preloadedState: {
            SessionID: "",
            SessionInfo: undefined,
            ShowRenewSession: false,
            InternetDown: false,
            currentNavigation: {
                livedataRootContainer: { dataRoot: undefined },
                page: {
                    component: "filelist",
                },
            },
            ThirdPartyListState: '',
            ThirdPartyListExtraPayload: {},
            ListData: {
                FormList: [],
                FileList: [],
                LawyerList: [],
                NotaryList: [],
                InsuranceList: [],
                RealEstateBrokerList: [],
                PurchaserRealEstateBrokerList: [],
                ConveyancerList: [],
                MortgageBrokerList: [],
                MortgageLenderList: [],
                MortgageLenderSelectFieldList: [],
                LenderNames: [],
                DischargeLenderList: [],
                OtherPartyList: [],
                SelectFileList: [],
            },
            ActivityCenter: [],
            ActivityCenterUnread: 0,
            SideMenuReload: new Date().getTime(),
            ClientPortalState: {
                ModalType: '',
                PageName: 'ClientIntake'
            },
            Preference: {
                PinRightSideTab: "toggle",
            },
            Indicators: {
                MyDriveHasNewDoc: false,
                Activity: false
            }
        },
    })

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;